type FormFooterProps = {
  children: NonNullable<React.ReactNode>
}

export function FormFooter({ children }: FormFooterProps) {
  return (
    <footer className="d-f fd-c ai-c g-2 g-3@md pl-2@iframe pr-2@iframe pb-2@iframe">
      {children}
    </footer>
  )
}
